import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, Event, NavigationEnd} from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private currentNav: INavigationData = null;
  private currentNavPromise = new BehaviorSubject<INavigationData>(this.currentNav);
  public $currentNav = this.currentNavPromise.asObservable();

  constructor(private titleService:Title,private metaService:Meta,private router: Router) {
    this.navigation();
  }
  navigation(){
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        let url = event.url;
        if (url) {
          const navData: INavigationData = {
            route: url.replace('/', ''),
            routeType: 1
          }
          sessionStorage.setItem('previousUrl',window.location.href)
          switch (navData.route) {
            case "user/dashboard": {
              navData.routeType = 0;
              this.titleService.setTitle('Dashboard');
              this.metaService.updateTag({ name: 'description', content: 'To View All Insightful Charts and Reports.' });
              break;
            }
            case "user/record/tracker": {
              navData.routeType = 1;
              this.titleService.setTitle('Record Tracker');
              this.metaService.updateTag({ name: 'description', content: 'To View All Records.' });
              break;
            }
            case "user/profile/overview": {
              navData.routeType = 4;
              this.titleService.setTitle('User Profile');
              this.metaService.updateTag({ name: 'description', content: 'To View User Profile.' });
              break;
            }
            case "user/supplier/create": {
                navData.routeType = 9;
                this.titleService.setTitle('Create Supplier');
                this.metaService.updateTag({ name: 'description', content: 'To Create New Supplier.' });
                break;
              }
              case "user/modify-supplier": {
                navData.routeType = 31;
                this.titleService.setTitle('Modify Supplier');
                this.metaService.updateTag({ name: 'description', content: 'To Modify Supplier.' });
                break;
              }
            case "user/master-data/legal-entity": {
              navData.routeType = 10;
              this.titleService.setTitle('Legal Entity MDM');
              break;
            }
            case "user/master-data/le-bu": {
                navData.routeType = 72;
                this.titleService.setTitle('LE BU Relationship MDM');
                break;
            }
            case "user/master-data/sertica-le": {
                navData.routeType = 73;
                this.titleService.setTitle('SERTICA UNIT-D365 LE CONFIGURTION MDM');
                break;
            }
            case "user/master-data/country": {
                navData.routeType = 11;
                this.titleService.setTitle('Country MDM');
                break;
            }
            case "user/master-data/currency": {
                navData.routeType = 12;
                this.titleService.setTitle('Currency MDM');
                break;
            }
            case "user/master-data/sales-tax": {
                navData.routeType = 13;
                this.titleService.setTitle('Sales Tax MDM');
                break;
            }
            case "user/master-data/group-procurement": {
                navData.routeType = 14;
                this.titleService.setTitle('Group Procurement Approvers MDM');
                break;
            }
            case "user/admin/master-status": {
                navData.routeType = 79;
                this.titleService.setTitle('Status');
                break;
            }
              case "user/admin/sla": {
                navData.routeType = 80;
                this.titleService.setTitle('SLA');
                break;
            }
            case "user/master-data/error-code-list": {
                navData.routeType = 78;
                this.titleService.setTitle('Error Code List MDM');
                break;
            }
            case "user/master-data/supplier-list": {
                navData.routeType = 22;
                this.titleService.setTitle('D365 Database');
                break;
            }
            case "user/master-data/rejection-reason": {
              navData.routeType = 16;
              this.titleService.setTitle('Reason Codes MDM');
              break;
            }
            case "user/master-data/icons-error": {
                navData.routeType = 88;
                this.titleService.setTitle('Master Data Info Message / Error Message MDM');
                break;
              }
            case "user/master-data/payment-method": {
                navData.routeType = 17;
                this.titleService.setTitle('Method of Payment MDM');
                break;
            }
            case "user/master-data/velocity-form-input-fields": {
                navData.routeType = 18;
                this.titleService.setTitle('Velocity Form Input Fields MDM');
                break;
            }
            case "user/master-data/sertica-form-input-fields": {
                navData.routeType = 19;
                this.titleService.setTitle('Sertica Form Input Fields MDM');
                break;
            }
            case "user/master-data/velocity-organization": {
                navData.routeType = 25;
                this.titleService.setTitle('Velocity Organisation Configuration Table MDM');
                break;
            }
            case "user/master-data/contact-info": {
                navData.routeType = 113;
                this.titleService.setTitle('Contact Information Purpose Table MDM');
                break;
            }
            case "user/master-data/sertica-configuration": {
                navData.routeType = 26;
                this.titleService.setTitle('Sertica Configuration MDM');
                break;
            }
            case "user/master-data/ls-retail-form-input-fields": {
                navData.routeType = 27;
                this.titleService.setTitle('LS Retail Form Input Fields MDM');
                break;
            }
            case "user/master-data/terms-of-payment": {
                navData.routeType = 28;
                this.titleService.setTitle('Terms of Payment MDM');
                break;
            }
              case "user/master-data/global-field-config": {
                navData.routeType = 29;
                this.titleService.setTitle('Global Fields Configuration');
                break;
            }
            case "user/master-data/supplier-change-log": {
              navData.routeType = 99;
              this.titleService.setTitle('Supplier Change Log');
              break;
            }
            case "user/master-data/sertica-database": {
                navData.routeType = 101;
                this.titleService.setTitle('Sertica Database');
                break;
            }
            case "user/master-data/velocity-database": {
                navData.routeType = 102;
                this.titleService.setTitle('Velocity Database');
                break;
            }
            case "user/master-data/lsretail-database": {
                navData.routeType = 103;
                this.titleService.setTitle('LSRetail Database');
                break;
            }
            case "user/master-data/d365-md-change-log": {
              navData.routeType = 106;
              this.titleService.setTitle('D365 MD Change Log');
              break;
            }
            case "user/admin/user-management": {
              navData.routeType = 20;
              this.titleService.setTitle('User Management');
              break;
            }
            case "user/admin/role-management": {
              navData.routeType = 21;
              this.titleService.setTitle('Role Management');
              break;
            }
            case "user/admin/column-settings": {
              navData.routeType = 23;
              this.titleService.setTitle('Column Settings');
              break;
            }
            case "user/admin/announcement": {
              navData.routeType = 35;
              this.titleService.setTitle('System Announcement Config');
              break;
            }
             case "user/admin/manual-email-template": {
              navData.routeType = 6;
              this.titleService.setTitle('Manual Email Template');
              break;
            }
             case "user/admin/auto-email-template": {
              navData.routeType = 7;
              this.titleService.setTitle('Auto Email Template');
              break;
            }
            case "user/admin/app-configuration": {
                navData.routeType = 104;
                this.titleService.setTitle('Application Configuration');
                break;
            }
            case "user/admin/file-type": {
              navData.routeType = 50;
              this.titleService.setTitle('File Type Management');
              break;
            }
            case "user/admin/user-activity": {
              navData.routeType = 65;
              this.titleService.setTitle('User Activity Logs');
              break;
            }
             case "user/admin/email-change-log": {
              navData.routeType = 107;
              this.titleService.setTitle('Email Change Log');
              break;
            }
            case "user/admin/default-config": {
                navData.routeType = 69;
                this.titleService.setTitle('Field Usage Across the Systems Config');
                break;
              }
            case "user/admin/sales-tax-scripts": {
                navData.routeType = 66;
                this.titleService.setTitle('Sales Tax Group Scripts');
                break;
            }
            case "user/admin/payment-method-scripts": {
                navData.routeType = 67;
                this.titleService.setTitle('Payment Method Scripts');
                break;
            }
            case "user/admin/velocity-scripts": {
                navData.routeType = 68;
                this.titleService.setTitle('Velocity Scripts');
                break;
            }
            case "user/admin/data-change-logger": {
              navData.routeType = 70;
              this.titleService.setTitle('Data Change Logger');
              break;
            }
            case "user/admin/update-request-log": {
              navData.routeType = 110;
              this.titleService.setTitle('Update Request Log');
              break;
            }
            case "user/admin/notification-log": {
              navData.routeType = 111;
              this.titleService.setTitle('Notification Log');
              break;
            }
            case "user/super-admin/client": {
              navData.routeType = 100;
              this.titleService.setTitle('Client Management');
              break;
            }
             case "user/introduction/astro": {
              navData.routeType = 112;
              this.titleService.setTitle('Introduction to Astro');
              break;
            }
              case "user/master-data/special-lob-list": {
              navData.routeType = 114;
              this.titleService.setTitle('Special LOB Database');
              break;
            }
             case "user/other-requests/other": {
              navData.routeType = 115;
              this.titleService.setTitle('Other Requests');
              break;
            }
             case "user/other-requests/bulk-block-update": {
              navData.routeType = 116;
              this.titleService.setTitle('Bulk Block/Update Requests');
              break;
            }
            case "user/other-requests/create-update-employee-vendor": {
              navData.routeType = 117;
              this.titleService.setTitle('Create/Update Employee Vendor');
              break;
            }
            default: {
              navData.routeType = 10000000;
              this.titleService.setTitle('Astro Portal');
              this.metaService.updateTag({ name: 'description', content: 'Welcome to our Portal! Explore our features and services.' });
            }
          }
          if(navData.route){
            if(navData?.route?.includes('user/record/view')){
                navData.routeType = 2;
                this.titleService.setTitle('Record View');
                this.metaService.updateTag({ name: 'description', content: 'To View Record Details.' });
              }
               if (navData?.route?.includes('user/other-requests/other')) {
                navData.routeType = 115;
                this.titleService.setTitle('Other Requests');
                this.metaService.updateTag({ name: 'description', content: 'To View Other Requests.' });
              }
              if (navData?.route?.includes('user/other-requests/bulk-block-update')) {
                navData.routeType = 116;
                this.titleService.setTitle('Bulk Block/Update Requests');
                this.metaService.updateTag({ name: 'description', content: 'To View Bulk Block/Update Requests.' });
              }
               if (navData?.route?.includes('user/other-requests/create-update-employee-vendor')) {
                navData.routeType = 117;
                this.titleService.setTitle('Create/Update Employee Vendor');
                this.metaService.updateTag({ name: 'description', content: 'To Create or Update Employee Vendor.' });
              }
                if (navData?.route?.includes('user/other-requests/extend-to-lob')) {
                navData.routeType = 118;
                this.titleService.setTitle('Extend to LOB');
                this.metaService.updateTag({ name: 'description', content: 'To Extend Request to LOB.' });
              }
              if (navData?.route?.includes('user/master-data/supplier-view')) {
                navData.routeType = 3;
                this.titleService.setTitle('Supplier Details View');
                this.metaService.updateTag({ name: 'description', content: 'To View Supplier Details.' });
              }
            if(navData?.route?.includes('user/supplier/create')){
              navData.routeType = 9;
              this.titleService.setTitle('Create Supplier');
              this.metaService.updateTag({ name: 'description', content: 'To Create New Supplier.' });
            }
             if(navData?.route?.includes('user/supplier/reopen')){
              navData.routeType = 8;
              this.titleService.setTitle('Create Supplier');
              this.metaService.updateTag({ name: 'description', content: 'To Create New Supplier.' });
            }
            if(navData?.route?.includes('user/supplier/update')){
              navData.routeType = 5;
              this.titleService.setTitle('Update Supplier');
              this.metaService.updateTag({ name: 'description', content: 'To Update New Supplier.' });
            }
             if(navData?.route?.includes('user/master-data/supplier-list')){
              navData.routeType = 22;
              this.titleService.setTitle('D365 Database View');
              this.metaService.updateTag({ name: 'description', content: 'To View Supplier.' });
            }
            if (navData?.route?.includes('user/master-data/sertica-database')) {
  navData.routeType = 101;
  this.titleService.setTitle('Sertica Database');
} else if (navData?.route?.includes('user/master-data/velocity-database')) {
  navData.routeType = 102;
  this.titleService.setTitle('Velocity Database');
} else if (navData?.route?.includes('user/master-data/lsretail-database')) {
  navData.routeType = 103;
  this.titleService.setTitle('LSRetail Database');
} else if (navData?.route?.includes('user/admin/email-controller')) {
    navData.routeType = 109;
    this.titleService.setTitle('EMAIL TEMPLATE CONTROLLER');
}

          }
          this.currentNav = navData;
          this.currentNavPromise.next(navData);
        }
      }

    });
  }
}

export interface INavigationData {
  route: string;
  routeType: number;
}
